import { CardGeneralResultComponent } from './card-general-result/card-general-result.component'
import { ButtonComponent } from './button/button.component'
import { EmbedComponent } from './embed/embed.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContainerComponent } from './container/container.component'
import { ImageComponent } from './image/image.component'
import { ImageLogoComponent } from './image-logo/image-logo.component'
import { LinkComponent } from './link/link.component'
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { PipesModule } from '../../pipes/pipes.module'
import { ModalComponent } from './modal/modal.component'
import { PaginatorComponent } from './paginator/paginator.component'
import { SimpleLinkComponent } from './simple-link/simple-link.component'
import { RouterModule } from '@angular/router'
import { WebsiteCardProgramComponent } from './website-card-program/website-card-program.component'
import { WebsiteCardTitleComponent } from './website-card-title/website-card-title.component'
import { WebsiteCardArticleFeaturedComponent } from './website-card-article-featured/website-card-article-featured.component'
import { WebsiteArticleBannerFeaturedComponent } from './website-article-banner-featured/website-article-banner-featured.component'
import { H1Component } from './h1/h1.component'
import { VideoPlayerComponent } from './video-player/video-player.component'
import { YouTubePlayerModule } from '@angular/youtube-player'
import { BackToTopComponent } from './back-to-top/back-to-top.component'
import { LinkIconComponent } from './link-icon/link-icon.component'
import { PathLinkComponent } from './path-link/path-link.component'
import { BannerItemComponent } from './banner-item/banner-item.component'
import { TextComponent } from './text/text.component'
import { AccordionComponent } from './accordion/accordion.component'
import { NgbNavModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap'
import { CardHorizontalImageLinkComponent } from './card-horizontal-image-link/card-horizontal-image-link.component'
import { CardEventComponent } from './card-event/card-event.component'
import { BannerNewComponent } from './banner-new/banner-new.component'
import { CardNewComponent } from './card-new/card-new.component'
import { CardRelatedProgramComponent } from './card-related-program/card-related-program.component'
import { RelatedContentComponent } from './related-content/related-content.component'
import { MapsComponent } from './maps/maps.component'
import { AgmCoreModule } from '@agm/core'
import { VideoGalleryComponent } from './video-gallery/video-gallery.component'
import { NgxJsonLdModule } from 'ngx-json-ld'
import { BannerItemDetailComponent } from './banner-item-detail/banner-item-detail.component'
import { ShowItemOnUpScrollDirective } from './directives/show-item-on-up-scroll.directive'

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    PdfViewerModule,
    RouterModule,
    YouTubePlayerModule,
    NgbNavModule,
    NgbAccordionModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAVHQjGmaK9pU0as9UVBuE_aKe_d10ZBvU',
    }),
    NgxJsonLdModule,
  ],
  declarations: [
    ContainerComponent,
    ImageComponent,
    PdfViewerComponent,
    EmbedComponent,
    ModalComponent,
    ButtonComponent,
    PaginatorComponent,
    ImageLogoComponent,
    LinkComponent,
    SimpleLinkComponent,
    WebsiteCardProgramComponent,
    WebsiteCardTitleComponent,
    WebsiteCardArticleFeaturedComponent,
    WebsiteArticleBannerFeaturedComponent,
    H1Component,
    VideoPlayerComponent,
    BackToTopComponent,
    LinkIconComponent,
    BannerItemComponent,
    LinkIconComponent,
    TextComponent,
    AccordionComponent,
    CardHorizontalImageLinkComponent,
    PathLinkComponent,
    MapsComponent,
    CardNewComponent,
    BannerNewComponent,
    RelatedContentComponent,
    CardEventComponent,
    CardRelatedProgramComponent,
    VideoGalleryComponent,
    CardGeneralResultComponent,
    BannerItemDetailComponent,
    ShowItemOnUpScrollDirective
  ],
  exports: [
    ContainerComponent,
    ImageComponent,
    PdfViewerComponent,
    EmbedComponent,
    ModalComponent,
    ButtonComponent,
    PaginatorComponent,
    ImageLogoComponent,
    LinkComponent,
    SimpleLinkComponent,
    WebsiteCardProgramComponent,
    WebsiteCardTitleComponent,
    WebsiteCardArticleFeaturedComponent,
    WebsiteArticleBannerFeaturedComponent,
    H1Component,
    VideoPlayerComponent,
    BackToTopComponent,
    LinkIconComponent,
    TextComponent,
    AccordionComponent,
    CardHorizontalImageLinkComponent,
    LinkIconComponent,
    BannerItemComponent,
    PathLinkComponent,
    MapsComponent,
    CardEventComponent,
    CardNewComponent,
    CardRelatedProgramComponent,
    BannerNewComponent,
    RelatedContentComponent,
    VideoGalleryComponent,
    CardGeneralResultComponent,
    BannerItemDetailComponent,
    ShowItemOnUpScrollDirective
  ],
  providers: [PipesModule],
})
export class SharedModule {}
